import {
  USER_LIST_LOADING,
  USER_LIST_SUCCESS,
  ADMIN_USER_TEAM_SUCCESS,
  ADMIN_LIST_LOADING,
  ADMIN_LIST_PAGE_CHANGE,
  ADMIN_LIST_SEARCH_TEXT,
  ADMIN_LIST_SEARCHING,
  ADMIN_LIST_CLEARING,
} from 'store/constants/userList';

const InitailState = {
  loading: false,
  data: [],
  adminTeams: [],
  adminListLoading: false,
  adminTeamCurrentPage: 1,
  adminTeamLastPage: 0,
  hadData: false,
  isSearching: false,
  isClearingAll: false,
};

const formatListData = (data = []) => {
  const formatedData = {};
  data.forEach((user) => {
    const userName = user?.username;
    const name = user?.name;
    if (userName && name) {
      formatedData[userName] = name;
    }
  });
  return formatedData;
};

function userList(state = InitailState, action) {
  switch (action.type) {
    case USER_LIST_LOADING:
      return { ...state, loading: true };
    case ADMIN_LIST_LOADING:
      return { ...state, adminListLoading: true };
    case ADMIN_LIST_PAGE_CHANGE:
      return { ...state, adminTeamCurrentPage: action.payload };
    case ADMIN_LIST_SEARCH_TEXT:
      return { ...state, adminListSearchText: action.payload };
    case USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...state.data, ...formatListData(action?.payload?.data) },
      };
    case ADMIN_LIST_SEARCHING:
      return { ...state, isSearching: true, adminTeamCurrentPage: 1 };
    case ADMIN_LIST_CLEARING:
      return { ...state, isClearingAll: true };
    case ADMIN_USER_TEAM_SUCCESS:
      const list = action?.payload?.data || [];
      const isLoadMore = action?.extra?.isLoadMore;
      const clearAll = action?.extra?.clearAll;
      const pagination = action?.payload?.pagination || {};
      const { last_page } = pagination;

      let adminTeamLastPage = isNaN(Number(last_page))
        ? Number(0)
        : Number(last_page);

      const calculatedTeams =
        (list || [])?.map((d) => ({
          value: String(d.id),
          name: d.name,
        })) ?? [];

      let teamToUse = calculatedTeams;
      if (isLoadMore) {
        teamToUse = [...state.adminTeams, ...teamToUse];
      }
      return {
        ...state,
        adminListLoading: false,
        adminTeamLastPage,
        adminTeams: teamToUse,
        hadData: state.hadData || !!teamToUse.length,
        isSearching: false,
        isClearingAll: false,
      };
    default:
      return state;
  }
}

export default userList;
